import { useSetRecoilState } from 'recoil';
import { useHippoText } from '../../hooks/useHippoText';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import ViewInformationModal from '../ViewInformationModal/ViewInformationModal';
import { onsaProgressSelector } from '../../recoil/selectors/onsaProgressSelector';

const ViewIndicativeOfferModal = ({
    showModal,
    closeModal,
    goNext
}: {
    showModal: boolean;
    closeModal: () => void;
    goNext: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { wizardGotoStep } = useWizardNavigation();
    const setOnsaProgress = useSetRecoilState(onsaProgressSelector);
    const QUICKLY_CALCULATE_PRICE_STEP = 2;

    const goToQuicklyCalculatePriceStep = (): void => {
        setOnsaProgress((prevStep) => ({
            ...prevStep,
            currentStep: QUICKLY_CALCULATE_PRICE_STEP
        }));

        wizardGotoStep('CoverableInformationPage');
    };

    return (
        <ViewInformationModal
            closeModal={closeModal}
            showModal={showModal}
            modalProps={{
                title: getHippoText('DSS-INFO-MODAL-UVPLOB-NO-LICENSE-PLATE-TITLE'),
                description: '',
                rawHtmlDescription: getHippoText(
                    'DSS-INFO-MODAL-UVPLOB-NO-LICENSE-PLATE-TITLE -BODY'
                ),
                mainButtonText: getHippoText('DSS-COMMON-CONTINUE'),
                isShowSecondaryButton: true,
                onSecondaryButtonClick: goToQuicklyCalculatePriceStep,
                secondaryButtonTheme: 'ghost',
                secondaryButtonText: getHippoText(
                    'DSS-INFO-MODAL-UVPLOB-NO-LICENSE-PLATE-RECALCULATE'
                ),
                onMainButtonClick: goNext
            }}
        />
    );
};

export default ViewIndicativeOfferModal;
